import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './managementblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchManagementInfo } from '../../../services/api'; // Новая функция

const ManagementBlock = () => {
    const { settings } = useAccessibility();
    const [managementData, setManagementData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchManagementInfo();
                // Данные теперь в response.data[0].attributes
                setManagementData(response.data[0].attributes);
                console.log('Management data:', response.data[0].attributes);
            } catch (err) {
                console.error('Error fetching management data:', err);
                setError('Не удалось загрузить данные о руководстве');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='РУКОВОДСТВО'
            headerColor={textColor}
        >
            <div>Загрузка данных о руководстве...</div>
        </Block>
    );

    if (error) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='РУКОВОДСТВО'
            headerColor={textColor}
        >
            <div>{error}</div>
        </Block>
    );

    if (!managementData) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='РУКОВОДСТВО'
            headerColor={textColor}
        >
            <div>Данные не найдены</div>
        </Block>
    );

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='РУКОВОДСТВО'
            headerColor={textColor}
            id='management'
            aria-label="Руководство организации"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* Руководитель организации */}
                        {managementData.Director && (
                            <section aria-labelledby="director">
                                <h4 id="director" className={style.header} style={{ color: textColor }}>
                                    {managementData.Director.AreaOfWork || 'Руководитель организации'}
                                </h4>
                                <div className={style.text} style={{ color: textColor }}>
                                    <p><strong>ФИО:</strong> {managementData.Director.FullName}</p>
                                    <p><strong>Должность:</strong> {managementData.Director.Job}</p>
                                </div>
                            </section>
                        )}

                        {/* Заместители */}
                        {managementData.ViceDirector && managementData.ViceDirector.length > 0 && (
                            <section aria-labelledby="deputies">
                                <h4 id="deputies" className={style.header} style={{ color: textColor }}>
                                    Заместители руководителя
                                </h4>
                                <div className={style.text} style={{ color: textColor }}>
                                    {managementData.ViceDirector.map((deputy) => (
                                        <div key={deputy.id} className={style.person} aria-labelledby={`deputy-${deputy.id}`}>
                                            <h5 id={`deputy-${deputy.id}`} className={style.subheader} style={{ color: textColor }}>
                                                {deputy.AreaOfWork}
                                            </h5>
                                            <p><strong>ФИО:</strong> {deputy.FullName}</p>
                                            <p><strong>Должность:</strong> {deputy.Job}</p>
                                            {deputy.Address && (
                                                <p><strong>Адрес:</strong> {deputy.Address}</p>
                                            )}
                                            {deputy.Phone && (
                                                <p><strong>Телефон:</strong> {deputy.Phone}</p>
                                            )}
                                            {deputy.Email && (
                                                <p>
                                                    <strong>Email:</strong>{' '}
                                                    <Link 
                                                        href={`mailto:${deputy.Email}`}
                                                        children={deputy.Email}
                                                        color={linkColor}
                                                        aria-label={`Написать письмо ${deputy.FullName}`}
                                                    />
                                                </p>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </section>
                        )}

                        {/* Руководители филиалов */}
                        {managementData.AreaManagement && managementData.AreaManagement.length > 0 && (
                            <section aria-labelledby="branch-managers">
                                <h4 id="branch-managers" className={style.header} style={{ color: textColor }}>
                                    Руководители обособленных структурных подразделений
                                </h4>
                                <div className={style.text} style={{ color: textColor }}>
                                    {managementData.AreaManagement.map((manager) => (
                                        <div key={manager.id} className={style.person} aria-labelledby={`branch-${manager.id}`}>
                                            <h5 id={`branch-${manager.id}`} className={style.subheader} style={{ color: textColor }}>
                                                {manager.Area}
                                            </h5>
                                            <p><strong>ФИО:</strong> {manager.FullName}</p>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        )}
                    </div>
                </div>
            </FadeIn>
        </Block>
    )
}

export default ManagementBlock;